import React, { Component } from 'react'
import { Button } from 'hljd'
import store from '../store'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import { MARKETING_CENTER_PATH_A } from '@constant'

@observer
export default class extends Component {
  submit = () => {
    const {
      shop: { withdraw, pay_money },
      payBond
    } = store
    if (withdraw - pay_money >= 0) {
      let params = {
        agent: 'wallet',
        kind: '3',
        return: MARKETING_CENTER_PATH_A
      }
      payBond(params, 'wallet')
    }
  }

  render() {
    const {
      shop: { withdraw, pay_money },
      disabled
    } = store

    return (
      <div className={Styles.balance}>
        <div className={Styles.tip}>
          <span>提醒：</span>当前可提现收入即为您可用的余额
        </div>

        <div className={Styles.account}>
          <div className={Styles.count}>
            当前可用余额为：<span style={{ color: '#ff705e' }}>
              ¥ {withdraw}
            </span>
          </div>
          <div className={Styles.count} style={{ marginTop: 20 }}>
            购买当前服务需扣款：<span>¥ {pay_money}.00</span>
          </div>
        </div>

        <div className={Styles.btnBox}>
          <Button type="primary" onClick={this.submit} disabled={disabled}>
            立即缴纳
          </Button>
        </div>
      </div>
    )
  }
}
